import React from "react";

type TagProps = {
  isBtn?: boolean;
  text: string;
  color?: string;
  active?: boolean;
  onClickHandle: (value: string) => void;
};

const Tag = ({
  isBtn = true,
  active,
  text,
  color,
  onClickHandle,
}: TagProps) => {
  const backgroundColor = !active ? "#fff" : color || "#293172";

  return isBtn ? (
    <button
      type="button"
      className={`tagContainer ${active ? "active" : "notActive"} ${
        color ? "hasColor" : ""
      }`}
      style={{
        backgroundColor,
      }}
      onClick={() => {
        onClickHandle(text);
      }}
    >
      {text}
    </button>
  ) : (
    <div
      className="tagContainer active hasColor"
      style={{
        backgroundColor,
      }}
    >
      {text}
    </div>
  );
};

export default Tag;
